import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import posthog from "posthog-js";

const PostHogPageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname;

    const routeNames = {
      "/": "Home Page",
      "/chat": "Start Reflection",
      "/downloadChat": "Download Chat",
      "/PastChats": "Past Chats",
      "/signUp": "Sign Up",
      "/adminPage": "Admin Page",
      "/config": "Config Page",
      "/intention_technique": "Intention Technique",
      "/id-card": "Future ID Card",
      "/create-your-id-card": "Create Your ID Card",
      "/final-id-card": "Final Screen",
      "/profile": "Profile Page",
      "/test": "Demo Page",
    };

    const pageTitle = routeNames[pathname] || `Page: ${pathname}`;

    posthog.capture("$pageview", {
      $current_url: window.location.href,
      page_title: pageTitle,
      properties: {
        name: "vedansh",
        last_nmae: "sharma",
      },
    });
  }, [location]);

  return null;
};

export default PostHogPageTracker;
